import { render, staticRenderFns } from "./MandateConflictList.vue?vue&type=template&id=2a12f2bc&scoped=true&"
import script from "./MandateConflictList.vue?vue&type=script&lang=js&"
export * from "./MandateConflictList.vue?vue&type=script&lang=js&"
import style0 from "./MandateConflictList.vue?vue&type=style&index=0&id=2a12f2bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a12f2bc",
  null
  
)

export default component.exports